import {DialogProgrammatic as Dialog, LoadingProgrammatic as Loading} from 'buefy';
import functions from "../../services/functions";
import database from "@/services/database";

export function remove(id, callback = null) {
    Dialog.confirm({
        type: 'is-danger',
        title: 'Apagar pedido?',
        message: 'Cuidado esta ação é irreversível',
        confirmText: 'Apagar',
        cancelText: 'Cancelar',
        async onConfirm() {
            const loading = Loading.open();
            try {
                await database.collection('orders').doc(id).delete();
                if (callback) {
                    callback(id)
                }
            } catch (e) {
                console.error(e);
            }
            loading.close();
        }
    });
}

/**
 * Criar um novo pedido
 * @param products
 * @param comment
 */
export function create(products, comment = null) {
    const createOrder = functions.httpsCallable('createOrder');
    return createOrder({products, comment});
}